import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useMarkExpeditionAsDelivered } from "../../../apis";
import { ForceCloseExpeditionModalProps } from "./ForceCloseExpeditionModal.types";

import styles from "./ForceCloseExpeditionModal.module.scss";

const ForceCloseExpeditionModal = ({
  orderId,
  isOpen,
  onClose,
  refetchDetails,
  refetchList
}: ForceCloseExpeditionModalProps) => {
  const { t } = useTranslation();

  const markExpeditionAsDelivered = useMarkExpeditionAsDelivered({
    onSuccess: () => {
      toast.success(t("Order has been force-closed as delivered"));
      refetchDetails?.();
      refetchList();
      onClose();
    }
  });

  const handleConfirm = () => {
    markExpeditionAsDelivered.mutate(orderId);
  };

  return (
    <Modal
      isOpen={isOpen}
      title={t("Force-close as delivered")}
      okText={t("Force-close")}
      onOk={handleConfirm}
      isLoading={markExpeditionAsDelivered.isLoading}
      contentClassName={styles.forceCloseExpeditionModal}
      onClose={onClose}
    >
      <p className={styles.forceCloseExpeditionModal_warning}>
        {t(
          "Use this only if the customer cannot confirm delivery via WhatsApp."
        )}
      </p>
      <p className={styles.forceCloseExpeditionModal_text}>
        {t(
          "Most expedition orders close automatically once the customer confirms reception. This action manually marks the order as delivered."
        )}
      </p>
    </Modal>
  );
};

export default ForceCloseExpeditionModal;
